/**
 * LD Product Page - Main module for product page functionality
 * =================================================
 * 
 * This module initializes all product page components:
 * - Accordions (ld-product-accordions.js)
 * - Payment Buttons (ld-product-payment-buttons.js) 
 * - Variant Selector (ld-product-variants.js)
 * - Cart Form (ld-product-cart-form.js)
 */

/**
 * Initialize the main module
 */
function init() {
  console.log('LD Product Page: Main module loaded');
  
  // Initialize video functionality
  initVideoSupport();
  
  // All functionality is now handled by separate modules:
  // - ld-product-accordions.js - handles accordion functionality
  // - ld-product-payment-buttons.js - handles payment button display
  // - ld-product-variants.js - handles variant selector
  // - ld-product-cart-form.js - handles cart form and LD Cart Drawer integration
  
  console.log('LD Product Page: All modules initialized via separate files');
}

/**
 * Initialize video support with autoplay, loop, muted, and no controls
 */
function initVideoSupport() {
  const videos = document.querySelectorAll('.ld-product-page__video');
  
  if (videos.length === 0) {
    console.log('LD Product Page: No videos found');
    return;
  }
  
  console.log('LD Product Page: Initializing', videos.length, 'videos');
  
  videos.forEach((video, index) => {
    // Debug: Log video information
    const videoType = video.dataset.videoType || 'unknown';
    const videoUrl = video.dataset.videoUrl || 'unknown';
    console.log('LD Product Page: Video', index + 1, 'Type:', videoType, 'URL:', videoUrl);
    
    // Ensure video has required attributes for autoplay
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('preload', 'metadata');
    
    // Remove controls to ensure clean appearance
    video.removeAttribute('controls');
    
    // Add event listeners for better control
    video.addEventListener('loadstart', function() {
      console.log('LD Product Page: Video', index + 1, 'loading started');
      this.classList.add('loading');
    });
    
    video.addEventListener('loadeddata', function() {
      console.log('LD Product Page: Video', index + 1, 'data loaded');
      this.classList.remove('loading');
    });
    
    video.addEventListener('canplay', function() {
      console.log('LD Product Page: Video', index + 1, 'can start playing');
      this.classList.remove('loading');
      // Try to play the video
      this.play().catch(error => {
        console.warn('LD Product Page: Autoplay failed for video', index + 1, error);
      });
    });
    
    video.addEventListener('play', function() {
      console.log('LD Product Page: Video', index + 1, 'started playing');
      this.classList.add('playing');
    });
    
    video.addEventListener('pause', function() {
      console.log('LD Product Page: Video', index + 1, 'paused');
      this.classList.remove('playing');
    });
    
    video.addEventListener('error', function(e) {
      console.error('LD Product Page: Video', index + 1, 'error:', e);
      console.error('LD Product Page: Video URL:', videoUrl);
      console.error('LD Product Page: Video source:', this.querySelector('source')?.src);
      this.classList.remove('loading');
      this.classList.add('error');
    });
    
    // Handle intersection observer for better performance
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Video is visible, ensure it's playing
            if (video.paused) {
              video.play().catch(error => {
                console.warn('LD Product Page: Play failed for video', index + 1, error);
              });
            }
          } else {
            // Video is not visible, pause it to save resources
            if (!video.paused) {
              video.pause();
            }
          }
        });
      }, {
        threshold: 0.1 // Trigger when 10% of video is visible
      });
      
      observer.observe(video);
    }
  });
}



// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', init);
